export default __webpack_public_path__ + "static/media/python.86dd9680.svg";